import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const useExercisePageRedirect = () => {
  return usePagesRedirect('useExercisePageRedirect');
};
